export enum ImageType {
    Source = 0,
    ImitationRaw = 1
}
